import { remove } from './client'
import type { BackendMeta } from './types'

export type RemoveMember = BackendMeta<'/api/workspaces/{workspace_id}/members/{user_id}', 'delete'>
export type RemoveMemberPath = RemoveMember['path']
export type RemoveMemberResponse = RemoveMember['successResponse']
export type RemoveMemberRequest = undefined

type RemoveMemberParams = {
  workspaceId: string
  userId: string
}

export const removeMember = ({ userId, workspaceId }: RemoveMemberParams) =>
  remove<RemoveMemberRequest, RemoveMemberResponse, RemoveMemberPath>(
    `/api/workspaces/${workspaceId}/members/${userId}`,
    undefined,
  )
